// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"56a71c58","455":"6442db40","977":"336da3db"}[chunkId] + ".chunk.js";
};